export default __webpack_public_path__ + "static/media/star.68dcb381.png";